import { CircleImageConsts } from '@treneo/shared/constants';

import { styled } from '../../styled';

type Props = {
  size?: string | number;
};

export const CircleImage = styled('img')<Props>`
  display: block;
  border-radius: 50%;
  object-fit: cover;
  width: ${({ size = CircleImageConsts.defaultSize }) => size};
  height: ${({ size = CircleImageConsts.defaultSize }) => size};
`;
